import * as actionTypes from "./actionTypes";

const initState = {
  user_id: "",
  isglobal: false,
};

const loginReducer = function(state = initState, action) {
  const response = action.response;
  switch (action.type) {
    case actionTypes.SIGN_IN_USER_SUCCESS:
      return {
        ...state,
        user_id: response.userid,
        isglobal: response.isglobal,
      };
    case actionTypes.SIGN_IN_USER_ERROR:
      return initState;
    default:
      return state;
  }
};
export default loginReducer;
